export default "__VITE_ASSET__db63af49__"